const initialState = {
    options: [],
    options_count: 0,
    isReadingOptions: false
};

export default initialState;